export { default } from '../../blog/index';
